/* ═══════════════════════════════════════════════════════
   VAZIØ — Main JavaScript
═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ─── Audio ────────────────────────────────────────── */
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  let audioCtx = null;

  function ensureAudio() {
    if (!audioCtx) audioCtx = new AudioCtx();
    if (audioCtx.state === 'suspended') audioCtx.resume();
  }

  function playClick() {
    try {
      ensureAudio();
      const t = audioCtx.currentTime;
      const size = Math.floor(audioCtx.sampleRate * 0.055);
      const buf  = audioCtx.createBuffer(1, size, audioCtx.sampleRate);
      const data = buf.getChannelData(0);
      for (let i = 0; i < size; i++) data[i] = Math.random() * 2 - 1;
      const src  = audioCtx.createBufferSource();
      src.buffer = buf;
      const bp   = audioCtx.createBiquadFilter();
      bp.type = 'bandpass'; bp.frequency.value = 160; bp.Q.value = 0.45;
      const gain = audioCtx.createGain();
      gain.gain.setValueAtTime(0.5, t);
      gain.gain.exponentialRampToValueAtTime(0.001, t + 0.05);
      src.connect(bp); bp.connect(gain); gain.connect(audioCtx.destination);
      src.start(t); src.stop(t + 0.06);
    } catch(e) {}
  }

  document.addEventListener('mousedown', ensureAudio, { once: false });
  document.addEventListener('mousedown', playClick);

  /* ─── Custom Cursor ─────────────────────────────────── */
  const cursorEl = document.getElementById('cursor');
  const trailEl  = document.getElementById('cursor-trail');

  if (cursorEl && trailEl) {
    let cx = 0, cy = 0;

    document.addEventListener('mousemove', (e) => {
      cx = e.clientX; cy = e.clientY;
      cursorEl.style.left = cx + 'px';
      cursorEl.style.top  = cy + 'px';
      requestAnimationFrame(() => {
        trailEl.style.left = cx + 'px';
        trailEl.style.top  = cy + 'px';
      });
    });

    function refreshCursorTargets() {
      document.querySelectorAll(
        'a, button, .product-card, [role="button"], select, input, textarea, .pd-thumb, .size-btn, .color-swatch, .sort-select'
      ).forEach((el) => {
        el.addEventListener('mouseenter', () => cursorEl.classList.add('hovered'));
        el.addEventListener('mouseleave', () => cursorEl.classList.remove('hovered'));
      });
    }
    refreshCursorTargets();
    window.refreshCursorTargets = refreshCursorTargets;
  }

  /* ─── Page Transition ───────────────────────────────── */
  const transEl    = document.getElementById('page-transition');
  const loadingBar = document.getElementById('loading-bar');

  function runTransitionOut(cb) {
    if (!transEl) { cb && cb(); return; }
    transEl.classList.add('active');
    setTimeout(() => { cb && cb(); }, 350);
  }
  function runTransitionIn() {
    if (!transEl) return;
    setTimeout(() => {
      transEl.classList.remove('active');
      animateLoadingBar();
    }, 50);
  }
  function animateLoadingBar() {
    if (!loadingBar) return;
    loadingBar.style.transition = 'none';
    loadingBar.style.opacity = '1';
    loadingBar.style.width = '0%';
    requestAnimationFrame(() => {
      loadingBar.style.transition = 'width 0.6s cubic-bezier(0.22,1,0.36,1)';
      loadingBar.style.width = '100%';
    });
    setTimeout(() => { loadingBar.style.opacity = '0'; loadingBar.style.width = '0%'; }, 700);
  }

  // Intercept all internal navigation links
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
    if (link.target === '_blank') return;
    const isInternal = link.hostname === window.location.hostname;
    if (!isInternal) return;
    e.preventDefault();
    runTransitionOut(() => { window.location.href = href; });
  });

  window.addEventListener('pageshow', (e) => {
    if (e.persisted) runTransitionIn();
  });

  document.addEventListener('DOMContentLoaded', () => {
    runTransitionIn();
  });

  /* ─── Glitch Engine ─────────────────────────────────── */
  const glitchEl = document.getElementById('glitch-overlay');
  if (glitchEl) {
    function triggerGlitch() {
      glitchEl.classList.remove('glitching');
      void glitchEl.offsetWidth;
      glitchEl.classList.add('glitching');
      document.body.classList.add('glitch-active');
      setTimeout(() => {
        glitchEl.classList.remove('glitching');
        document.body.classList.remove('glitch-active');
      }, 220);
    }
    function scheduleGlitch() {
      const delay = 7000 + Math.random() * 18000;
      setTimeout(() => { triggerGlitch(); scheduleGlitch(); }, delay);
    }
    scheduleGlitch();
  }

  /* ─── Scroll-triggered Animations ──────────────────── */
  function initRevealAnimations() {
    const items = document.querySelectorAll('.animate-reveal');
    if (!items.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    items.forEach((el) => io.observe(el));
  }
  initRevealAnimations();

  /* ─── Header scroll behavior ────────────────────────── */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  /* ─── Mobile Menu ───────────────────────────────────── */
  const mobileBtn  = document.querySelector('.mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  if (mobileBtn && mobileMenu) {
    mobileBtn.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('open');
      mobileBtn.classList.toggle('open', isOpen);
      mobileBtn.setAttribute('aria-expanded', isOpen);
      mobileMenu.setAttribute('aria-hidden', !isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    mobileMenu.querySelectorAll('a').forEach((a) => {
      a.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        mobileBtn.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ─── Product Detail: Thumbnail Gallery ─────────────── */
  const mainImgEl = document.getElementById('pd-main-img-el');
  const thumbBtns = document.querySelectorAll('.pd-thumb');
  if (mainImgEl && thumbBtns.length) {
    thumbBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const src = btn.dataset.src;
        const alt = btn.dataset.alt;
        mainImgEl.style.opacity = '0';
        setTimeout(() => {
          mainImgEl.src = src;
          if (alt) mainImgEl.alt = alt;
          mainImgEl.style.opacity = '1';
        }, 200);
        thumbBtns.forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');
      });
    });
    mainImgEl.style.transition = 'opacity 0.25s ease';
  }

  /* ─── Product Detail: Variant Selector ─────────────── */
  if (window.productVariants && window.productOptions) {
    const variantIdInput = document.getElementById('variant-id');
    const priceEl        = document.getElementById('pd-price');
    const addBtn         = document.getElementById('add-to-cart-btn');
    const addBtnText     = document.getElementById('add-to-cart-text');
    let selectedOptions  = [];

    // Init from first available variant
    if (window.productVariants.length > 0) {
      const firstV = window.productVariants[0];
      selectedOptions = firstV.options ? [...firstV.options] : [];
    }

    function findVariant(options) {
      return window.productVariants.find((v) =>
        v.options && v.options.every((opt, i) => opt === options[i])
      );
    }

    function updateVariant() {
      const variant = findVariant(selectedOptions);
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) {
        const priceSpan = priceEl.querySelector('.price-main');
        if (priceSpan) {
          priceSpan.textContent = formatMoney(variant.price);
        }
      }
      if (addBtn && addBtnText) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtnText.textContent = 'Add to Cart';
        } else {
          addBtn.disabled = true;
          addBtnText.textContent = 'Sold Out';
        }
      }
    }

    document.querySelectorAll('.pd-size-row, .pd-color-swatches').forEach((group) => {
      const optionIndex = parseInt(group.dataset.optionIndex, 10);
      group.querySelectorAll('.size-btn, .color-swatch').forEach((btn) => {
        btn.addEventListener('click', () => {
          group.querySelectorAll('.size-btn, .color-swatch').forEach((b) => b.classList.remove('active'));
          btn.classList.add('active');
          selectedOptions[optionIndex] = btn.dataset.value;
          updateVariant();
        });
      });
    });
  }

  /* ─── Product Detail: Quantity ──────────────────────── */
  document.querySelectorAll('.qty-selector').forEach((sel) => {
    const input   = sel.querySelector('.qty-input');
    const minusBtn = sel.querySelector('.qty-minus');
    const plusBtn  = sel.querySelector('.qty-plus');
    if (!input) return;
    minusBtn && minusBtn.addEventListener('click', () => {
      const v = parseInt(input.value, 10);
      if (v > 1) input.value = v - 1;
    });
    plusBtn && plusBtn.addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  /* ─── Add to Cart (AJAX) ────────────────────────────── */
  const productForm = document.getElementById('product-form');
  const cartMsgEl   = document.getElementById('cart-message');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const addBtn     = document.getElementById('add-to-cart-btn');
      const addBtnText = document.getElementById('add-to-cart-text');
      if (!addBtn || addBtn.disabled) return;

      addBtn.disabled = true;
      if (addBtnText) addBtnText.textContent = 'Adding...';

      const formData = new FormData(productForm);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData,
        });
        const data = await res.json();
        if (res.ok) {
          if (addBtnText) addBtnText.textContent = 'Added ✓';
          showCartMessage('Added to cart.', 'success');
          updateCartCount();
          setTimeout(() => {
            if (addBtnText) addBtnText.textContent = 'Add to Cart';
            addBtn.disabled = false;
          }, 2000);
        } else {
          showCartMessage(data.description || 'Something went wrong.', 'error');
          if (addBtnText) addBtnText.textContent = 'Add to Cart';
          addBtn.disabled = false;
        }
      } catch (err) {
        showCartMessage('Network error. Please try again.', 'error');
        if (addBtnText) addBtnText.textContent = 'Add to Cart';
        addBtn.disabled = false;
      }
    });
  }

  function showCartMessage(msg, type) {
    if (!cartMsgEl) return;
    cartMsgEl.textContent = msg;
    cartMsgEl.className = 'cart-message ' + (type || '');
    cartMsgEl.hidden = false;
    setTimeout(() => { cartMsgEl.hidden = true; }, 4000);
  }

  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const countEl = document.querySelector('.cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    } catch(e) {}
  }

  /* ─── Cart page: AJAX qty update & remove ───────────── */
  async function updateCartItem(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      window.location.reload();
    } catch(e) { window.location.reload(); }
  }

  document.querySelectorAll('.cart-remove').forEach((btn) => {
    btn.addEventListener('click', () => updateCartItem(btn.dataset.key, 0));
  });

  document.querySelectorAll('.qty-selector').forEach((sel) => {
    const minusBtn = sel.querySelector('.qty-minus[data-key]');
    const plusBtn  = sel.querySelector('.qty-plus[data-key]');
    const inp      = sel.querySelector('.cart-qty');
    if (!inp || !minusBtn) return;
    const key = minusBtn.dataset.key;
    minusBtn.addEventListener('click', () => {
      const v = parseInt(inp.value, 10);
      if (v > 1) updateCartItem(key, v - 1);
    });
    plusBtn && plusBtn.addEventListener('click', () => {
      updateCartItem(key, parseInt(inp.value, 10) + 1);
    });
  });

  /* ─── Quick Add ─────────────────────────────────────── */
  document.querySelectorAll('.card-quick-add').forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      const originalText = btn.querySelector('span').textContent;
      btn.querySelector('span').textContent = '...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (res.ok) {
          btn.querySelector('span').textContent = 'Added ✓';
          updateCartCount();
          setTimeout(() => {
            btn.querySelector('span').textContent = originalText;
            btn.disabled = false;
          }, 2000);
        } else {
          btn.querySelector('span').textContent = originalText;
          btn.disabled = false;
        }
      } catch(e) {
        btn.querySelector('span').textContent = originalText;
        btn.disabled = false;
      }
    });
  });

  /* ─── Utility: Money Format ─────────────────────────── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ─── Scroll Animations on product cards ───────────── */
  function initCardAnimations() {
    const cards = document.querySelectorAll('.product-card');
    if (!cards.length || !window.IntersectionObserver) return;
    cards.forEach((c, i) => {
      c.style.opacity = '0';
      c.style.transform = 'translateY(20px)';
      c.style.transition = `opacity 0.6s ${i * 0.06}s cubic-bezier(0.22,1,0.36,1), transform 0.6s ${i * 0.06}s cubic-bezier(0.22,1,0.36,1)`;
    });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    cards.forEach((c) => io.observe(c));
  }
  initCardAnimations();

})();
